module.exports = __webpack_public_path__ + "img/dc_04.775ef693.jpg";